import { useFriendsData } from './useFriendsData'
import { useFriendsSearch } from './useFriendsSearch'
import { useFriendsActions } from './useFriendsActions'

export const useFriendsManager = () => {
  const dataHandlers = useFriendsData()
  const searchHandlers = useFriendsSearch()
  const actionHandlers = useFriendsActions(dataHandlers)

  const sendFriendRequest = (userId, message) => {
    return actionHandlers.sendFriendRequest(userId, message, searchHandlers.setSearchResults)
  }


  return {
    friendRequests: dataHandlers.friendRequests,
    sentRequests: dataHandlers.sentRequests,
    friends: dataHandlers.friends,
    searchResults: searchHandlers.searchResults,
    loading: actionHandlers.loading,
    searchLoading: searchHandlers.searchLoading,
    searchUsers: searchHandlers.searchUsers,
    sendFriendRequest,
    acceptRequest: actionHandlers.acceptRequest,
    declineRequest: actionHandlers.declineRequest,
    removeFriend: actionHandlers.removeFriend,
    refreshData: dataHandlers.refreshData
  }
}